import { Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { SNS_CONTENT_GENERATOR_ACCOUNTS } from '../accounts.js';

export interface AccountTabsProps {
  /** 現在表示中のaccountId（URLの `$accountId` パラメータ）。タブの選択状態表示に使う */
  activeAccountId: string;
}

/** @graph-connects none */
const tabBaseClassName =
  'px-4 py-2 text-sm font-medium rounded-t-lg border-b-2 transition-colors duration-[var(--transition-fast)]';

/** @graph-connects none */
const tabActiveClassName = 'border-[var(--color-accent-primary)] text-[var(--color-text-primary)]';

/** @graph-connects none */
const tabInactiveClassName =
  'border-transparent text-[var(--color-text-muted)] hover:text-[var(--color-text-primary)] hover:border-[var(--color-border-hover)]';

/**
 * @graph-stack cortex-admin
 * @graph-domain Marketing
 * @graph-business SNSコンテンツ生成のアカウント切り替えタブ。cortex-adminに既存のTabsコンポーネントが無いため新規作成した。
 * `/sns-content-generator/$accountId` へのURL遷移でアカウントを切り替える（生成途中のstateは切り替え時に破棄される想定）。
 * @graph-connects none
 */
export function AccountTabs({ activeAccountId }: AccountTabsProps) {
  const { t } = useTranslation();
  return (
    <div role="tablist" className="flex gap-1 border-b border-[var(--color-border)]">
      {SNS_CONTENT_GENERATOR_ACCOUNTS.map((account) => {
        const isActive = account.id === activeAccountId;
        return (
          <Link
            key={account.id}
            to="/sns-content-generator/$accountId"
            params={{ accountId: account.id }}
            role="tab"
            aria-selected={isActive}
            className={`${tabBaseClassName} ${isActive ? tabActiveClassName : tabInactiveClassName}`}
          >
            {t(account.displayNameKey)}
          </Link>
        );
      })}
    </div>
  );
}
